// extracted by mini-css-extract-plugin
export default {"poNumberField":"poNumberField---gYsgA"};